<template>
    <div class="my_charts" :style="{ width: width, height: height }"></div>
  </template>

  <script>
  import echarts from 'echarts'

  export default {
    name: "XEcharts",
    props: {
      width: {
        type: String,
        default: "500px",
      },
      height: {
        type: String,
        default: "500px",
      },
      options: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        myChart: null,
        fdFlag: null,
      };
    },
    watch: {
      options: {
        handler() {
          this.draw();
        },
        deep: true,
      },
    },
    components: {},
  
    computed: {},
  
    mounted() {
      // this.myChart = echarts.init(this.$el);
      this.draw();
      window.addEventListener("resize", this.handleWindowResize);
    },
  
    beforeDestroy() {
      window.removeEventListener("resize", this.handleWindowResize);
    },
  
    methods: {
      isTrue(options) {
        let type1 = false;
        let type2 = false;
        let type3 = false;
        let type4 = false;
        let type5 = false;
        let type6 = false;
  
        if (options.dataset && options.dataset instanceof Array) {
          for (let i = 0; i < options.dataset.length; i++) {
            if (
              options.dataset[i].hasOwnProperty("source") &&
              options.dataset[i].source instanceof Array &&
              options.dataset[i].source.length > 0
            ) {
              type5 = true;
              break;
            } else if (
              options.dataset[i].hasOwnProperty("source") &&
              options.dataset[i].source instanceof Object
            ) {
              const keys = Object.keys(options.dataset[i].source);
              let flag = 0;
              for (let j = 0; j < keys.length; j++) {
                if (options.dataset[i].source[keys[j]].length > 0) {
                  flag = 1;
                  break;
                }
              }
              if (flag === 1) {
                type6 = true;
                break;
              }
            }
          }
        }
        if (
          options.dataset &&
          options.dataset instanceof Object &&
          options.dataset.hasOwnProperty("source") &&
          options.dataset.source instanceof Array
        ) {
          if (options.dataset.source.length > 0) {
            type1 = true;
          }
        }
        if (
          options.dataset &&
          options.dataset instanceof Object &&
          options.dataset.hasOwnProperty("source") &&
          options.dataset.source instanceof Object
        ) {
          const keys = Object.keys(options.dataset.source);
          let flag = 0;
          for (let i = 0; i < keys.length; i++) {
            if (options.dataset.source[keys[i]].length > 0) {
              flag = 1;
              break;
            }
          }
          if (flag === 1) {
            type2 = true;
          }
        }
        if (options.series && options.series instanceof Object) {
          if (
            options.series.hasOwnProperty("data") &&
            options.series.data.length > 0
          ) {
            type3 = true;
          }
        }
        if (options.series && options.series instanceof Object) {
          const keys = options.series;
          let flag = 0;
          for (let i = 0; i < keys.length; i++) {
            if (keys[i].hasOwnProperty("data") && keys[i].data.length > 0) {
              flag = 1;
              break;
            }
          }
          if (flag === 1) {
            type4 = true;
          }
        }
  
        return type1 || type2 || type3 || type4 || type5 || type6;
      },
      draw() {
        if (!this.isTrue(this.options)) {
          const dom = this.$el;
          dom.innerHTML = "暂无数据";
          dom.style.cssText = `display: flex; justify-content: center; align-items: center; width: ${this.width}; text-align:center; color: grey; border: none;height: ${this.height}; line-height: ${this.height}; font-size: 14px`;
          dom.removeAttribute("_echarts_instance_");
        } else {
          this.$nextTick(function () {
            if (
              this.myChart != null &&
              this.myChart != "" &&
              this.myChart != undefined
            ) {
              this.myChart.dispose(); //销毁
            }
            let _this = this;
            this.myChart = echarts.init(this.$el);
            this.myChart && this.myChart.setOption(this.options);
            this.myChart &&
              this.myChart.getZr().on("click", params => {
                let pointInPixel = [params.offsetX, params.offsetY];
                if (this.myChart.containPixel("grid", pointInPixel)) {
                  let pointInGrid = this.myChart.convertFromPixel(
                    { seriesIndex: 0 },
                    pointInPixel,
                  );
                  let xIndex = pointInGrid[0];
                  _this.$bus.$emit("changeXAxisValue", xIndex);
                }
              });
          });
        }
      },
      showLoading() {
        this.myChart && this.myChart.showLoading();
      },
      hideLoading() {
        this.myChart && this.myChart.hideLoading();
      },
      handleWindowResize() {
        this.myChart && this.myChart.resize();
      },
    },
  };
  </script>
  <style lang="scss" scoped></style>
  